import { Component, OnInit, ViewChild } from '@angular/core';
import { FeedbackService } from '../service/feedback.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../shared/user.service';
import { DataTable } from 'primeng/primeng';
import { TabViewModule } from 'primeng/tabview';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectItem } from 'primeng/api';
import { PaginatorModule } from 'primeng/paginator';
import { FeedbackUpdateHistory } from '../model/feedback-update.model';

// import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {

  accountManagers: any[];
  accountManagerSelected: any = null;
  listcustomer: any[] = [];
  selectedCustomerId: any = null;
  //listfileName: any[] = [];
  selectedFileName: string = "";
  listSugHafrasha: any[] = [];
  listErrorCodes: any[] = [];
  selectedSugHafrasha: any = null;
  selectedErrorCode: any = null;
  listSugKupa: any[] = [];
  selectedSugKupa: any = null;
  listManagementName: any[] = [];
  selectedManagementName: any = null;
  //listMisparMezaheOved: any[] = [];
  selectedMisparMezaheOved: string = null;
  listStatusDescription: any[] = [];
  selectedStatus: any[] = [];
  listErrorCodesV4: any[] = [];
  selectedErrorCodeV4: any[] = [];
  resultTable: any[] = null;
  cols: any[];
  msgs: any[] = [];
  selectedCheckBox: any[];
  display: boolean = false;
  btnDialog: boolean = false;
  cloneArray: any = { FeedbackId: null, FileDepositId: null, Note: '', OriginalFileName: null, FeedbackStatudUpdateDate: null, Urgent: false };
  flag: boolean;
  selectedUrgent: boolean = false;
  selectedLegalTreatment: boolean = false;
  userDetails: any = null;
  @ViewChild('dt') dataTable: DataTable = null;
  tabActiveIndex: any = 0;
  feedbackStatisesPrecalculated: any[] = null;
  feedbackAccountManager30DaysPrecalculated: any[] = null;
  feedbackAccountManagerThisMonthPrecalculated: any[] = null;
  columns: SelectItem[];
  colsHistoryUpdate: any[];
  selectedColumns: any[];
  rowGroupMetadata: any;
  rowsLimit: number = 1000;
  rowsTobeUpdated: any = null;
  downloadFileGuid: any = null;
  showDownloadFileGuid: any = false;
  showFeedbackErrorCodeDescription: any = false;
  showFeedbackErrorCodeV4Description: boolean = false;
  FeedbackError: any = null;
  FeedbackV4Error: any = null;

  reportMonthes: any[] = [];
  //reportMonthSelected: any = null;
  reportMonthMultiSelected: any[] = null;
  chodeshMaskoret: any[] = [];
  //chodeshMaskoretSelected: any = null;
  chodeshMaskoretMultiSelected: any[] = null;
  reportNegative: any[] = [];
  reportNegativeSelected: any = null;
  updateHistory: FeedbackUpdateHistory[] = null;

  feedbackStatisesPrecalculatedLoading: boolean = false;
  feedbackAccountManager30DaysLoading: boolean = false;
  feedbackAccountManagerThisMonthLoading: boolean = false;

  resultsTypes: SelectItem[] = [
    { label: 'היזון חוזר', value: 'feedback' },
    { label: 'חל"ת', value: 'furlough' },
    { label: 'הכל', value: '' },
  ];
  resultsTypeSelected: string = 'feedback';


  constructor(private dataService: FeedbackService, private router: Router, private userService: UserService) {

    this.columns = [
      { label: 'זיהוי מעסיק', value: 'IdentityNumber' },
      { label: 'שם מעסיק', value: 'CustomerName' },
      { label: 'עובד', value: 'SHEM_PRATI' },
      { label: 'זיהוי עובד', value: 'MISPAR_MEZAHE_OVED' },
      { label: 'חודש שכר', value: 'CHODESH_MASKORET' },
      { label: 'שם קופה', value: 'SHEM_KUPA' },
      { label: 'סוג קופה', value: 'SUG_KUPA' },
      { label: 'סוג הפרשה', value: 'SUG_HAFRASHA' },
      { label: 'סכום', value: 'SCHUM_HAFRASHA' },
      { label: 'שיעור הפרשה', value: 'SHIUR_HAFRASHA' },
      { label: 'שכר מדווח', value: 'SACHAR_MEDUVACH' },
      { label: 'סטטוס הפקדה', value: 'Status' },
      { label: 'סיבת סטטוס', value: 'StatusDepositTreatmentDescription' },
      { label: 'חברה מנהלת', value: 'ManagementName' },
      { label: 'תאריך דיווח', value: 'ReportDateFormatted' },
      { label: 'שם קובץ', value: 'OriginalFileName' },
      { label: 'הערות', value: 'Notes' },
      { label: 'השתתף בדוח גביה', value: 'SignMonth' },
      { label: 'תיק מסלקה', value: 'TikMislaka' },
      { label: 'מספר מזהה רשומה', value: 'MISPAR_MEZAHE_RESHUMA' },
      { label: 'קוד שגיאה', value: 'ErrorCodeV4Id' },
      { label: 'טקסט שגיאה', value: 'ErrorCodeV4Text' },
      // { label: 'תאור שגיאה', value: 'ErrorCodeV4Description' },
      // { label: 'קוד שגיאה', value: 'FeedbackErrorCodeId' }
    ];
    this.colsHistoryUpdate = [
      {header: 'הערות', field: 'Notes'},
      {header: 'סטטוס שנקבע', field: 'StatusTargetName'},
      {header: 'סטטוס מקור', field: 'StatusOriginalName'},
      {header: 'תאריך עדכון', field: 'UpdateDate'},
      {header: 'סוג עדכון', field: 'Action'},
      {header: 'עדכון ע"י', field: 'UpdateByName'},
    ];

    this.selectedColumns = ['IdentityNumber', 'CustomerName', 'SHEM_PRATI', 'MISPAR_MEZAHE_OVED', 'CHODESH_MASKORET', 'SHEM_KUPA',
                            /*'SUG_KUPA',*/ 'SUG_HAFRASHA', 'SCHUM_HAFRASHA', /*'SHIUR_HAFRASHA',*/ /*'SACHAR_MEDUVACH',*/ 'Status',
                            'StatusDepositTreatmentDescription'
                            /*, 'ManagementName',*/ /*'UpdateUserId'*/ /*'FeedbackErrorCodeId'*/];

  }

  ngOnInit() {
    this.userService.getUserClaims().subscribe((data: any) => {
      this.userDetails = data;
    },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
      });

      this.dataService.getAccountManagersDDL().subscribe((result: any) => {
        this.accountManagers = result;
        // if (this.userDetails.ClientRoleSupport && this.accountManagers && this.accountManagers.length == 1) {
        //   this.accountManagerSelected = this.accountManagers[0].value;
        // }
        if (this.userDetails && this.userDetails.ClientRoleSupport && this.accountManagers && this.userDetails.UserName) {
          let item = this.accountManagers.find(f=>f.value == this.userDetails.UserName);
          if (item) {
            this.accountManagerSelected = item.value;
          }
        }
        this.accountManagerChanged();
      },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת מנהלי תיקים ');
      });

    //this.dataService.getCustomer().subscribe((result: any) => {
    //  this.listcustomer = result;
    //  this.listcustomer.unshift({ label: 'הכל', value: null });
    //},
      //(err: HttpErrorResponse) => {
      //  //this.router.navigate(['error-page/', err.error.ExceptionMessage])
      //  this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים ');
      //});

    // this.dataService.getFileName().subscribe((result: any) => {
    //   this.listfileName = result;
    //   this.listfileName.unshift({ label: 'הכל', value: null });
    // },
    //   (err: HttpErrorResponse) => {
    //     //this.router.navigate(['error-page/', err.error.ExceptionMessage])
    //     this.showMessage('error', '', 'תקלה בקבלת רשימת שם קובץ');
    //   });

    this.dataService.getSUG_HAFRASHA().subscribe((result: any) => {
      this.listSugHafrasha = result;
      this.listSugHafrasha.unshift({ label: 'הכל', value: null });
    },
      (err: HttpErrorResponse) => {
        //this.router.navigate(['error-page/', err.error.ExceptionMessage])
        this.showMessage('error', '', 'תקלה בקבלת רשימת סוג הפרשה');

      });

      
        this.listErrorCodes = [
          { label: 'כל הרשומות', value: null },
          { label: 'רשומות עם קוד שגיאה בלבד', value: 1 },
          { label: 'רשומות ללא קוד שגיאה בלבד', value: 2 },
        ];
      

    this.dataService.getSUG_KUPA().subscribe((result: any) => {
      this.listSugKupa = result;
      this.listSugKupa.unshift({ label: 'הכל', value: null });
    },
      (err: HttpErrorResponse) => {
        //this.router.navigate(['error-page/', err.error.ExceptionMessage])
        this.showMessage('error', '', 'תקלה בקבלת רשימת סוג קופה');
      });

    this.dataService.getManagementName().subscribe((result: any) => {
      this.listManagementName = result;
      this.listManagementName.unshift({ label: 'הכל', value: null });
    },
      (err: HttpErrorResponse) => {
        // this.router.navigate(['error-page/', err.error.ExceptionMessage])
        this.showMessage('error', '', 'תקלה בקבלת רשימת חברה מנהלת');
      });

    // this.dataService.getMisparMezaeOved().subscribe((result: any) => {
    //   this.listMisparMezaheOved = result;
    //   this.listMisparMezaheOved.unshift({ label: 'הכל', value: null });
    // },
    //   (err: HttpErrorResponse) => {
    //     //this.router.navigate(['error-page/', err.error.ExceptionMessage])
    //     this.showMessage('error', '', 'תקלה בקבלת רשימת עובדים');
    //   });

    this.dataService.getFeedbackStatusDDL().subscribe((result: any) => {
      this.listStatusDescription = result;
      //this.listStatusDescription.unshift({ label: 'הכל', value: null });
    },
      (err: HttpErrorResponse) => {
        //this.router.navigate(['error-page/', err.error.ExceptionMessage])
        this.showMessage('error', '', 'תקלה בקבלת סטטוסים');
      });

    this.dataService.GetFeedbackErrorCodesV4List().subscribe((result: any) => {
        this.listErrorCodesV4 = result;
      },
        (err: HttpErrorResponse) => {
          //this.router.navigate(['error-page/', err.error.ExceptionMessage])
          this.showMessage('error', '', 'תקלה בקבלת קודי שגיאה');
    });

    
    this.feedbackStatisesPrecalculatedLoading = true;
    this.dataService.getFeedbackStatisesPrecalculated().subscribe((result: any) => {
      this.feedbackStatisesPrecalculatedLoading = false;
      this.feedbackStatisesPrecalculated = result;
    },
      (err: HttpErrorResponse) => {
        this.feedbackStatisesPrecalculatedLoading = false;
        //this.router.navigate(['error-page/', err.error.ExceptionMessage])
        this.showMessage('error', '', 'תקלה בקבלת נתונים מחושבים מראש');
    });


    this.feedbackAccountManager30DaysLoading = true;
    this.dataService.getFeedbackAccountManager30DaysPrecalculated().subscribe((result: any) => {
      this.feedbackAccountManager30DaysLoading = false;
      this.feedbackAccountManager30DaysPrecalculated = result;
    },
      (err: HttpErrorResponse) => {
        this.feedbackAccountManager30DaysLoading = false;
        this.showMessage('error', '', 'תקלה בקבלת נתונים שעודכנו ב-30 ימים אחרונים');
    });

    this.feedbackAccountManagerThisMonthLoading = true;
    this.dataService.getFeedbackAccountManagerThisMonthPrecalculated().subscribe((result: any) => {
      this.feedbackAccountManagerThisMonthLoading = false;
      this.feedbackAccountManagerThisMonthPrecalculated = result;
    },
      (err: HttpErrorResponse) => {
        this.feedbackAccountManagerThisMonthLoading = false;
        this.showMessage('error', '', 'תקלה בקבלת נתונים שעודכנו בחודש קלנדרי נוכחי');
    });


      this.fillReportMonth();
      this.fillChodeshMaskoret();

      this.accountManagerChanged();


    // this.cols = [
    //   { field: 'IdentityNumber', header: 'זיהוי מעסיק' },
    //   { field: 'CustomerName', header: 'שם מעסיק' },
    //   { field: 'SHEM_KUPA', header: 'שם קופה' },
    //   { field: 'SUG_HAFRASHA', header: 'סוג הפרשה' },
    //   { field: 'SUG_KUPA', header: 'סוג קופה' },
    //   { field: 'ManagementName', header: 'חברה מנהלת' },
    //   { field: 'SCHUM_HAFRASHA', header: 'סכום הפרשה' },
    //   { field: 'SHIUR_HAFRASHA', header: 'שיעור הפרשה' },
    //   { field: 'SACHAR_MEDUVACH', header: 'שכר מדווח' },
    //   { field: 'MISPAR_MEZAHE_OVED', header: 'זיהוי עובד' },
    //   { field: 'SHEM_PRATI', header: 'שם עובד' },
    //   { field: 'Status', header: 'סטטוס' },
    //   { field: 'StatusDepositTreatmentDescription', header: 'סיבת סטטוס' },
    //   { field: 'CHODESH_MASKORET', header: 'חודש שכר' },
    //   { field: 'UpdateUserId', header: 'סטטוס נקבע על ידי משתמש' },
    //   //{ field: 'MISPAR_MEZAHE_RESHUMA', header: 'האם רשומה קיימת בקובץ הפקדות' },
    // ];

    this.cols = [
      // { field: 'FeedbackErrorCodeId', header: 'קוד שגיאה' },
      //{ field: 'ErrorCodeV4Description', header: 'תאור שגיאה' },
      { field: 'ErrorCodeV4Text', header: 'טקסט שגיאה' },
      { field: 'ErrorCodeV4Id', header: 'קוד שגיאה' },
      { field: 'MISPAR_MEZAHE_RESHUMA', header: 'מספר מזהה רשומה' },           
      { field: 'TikMislaka', header: 'תיק מסלקה' },  
      { field: 'Notes', header: 'הערות' },
      { field: 'SignMonth', header: 'השתתף בדוח גביה' },
      { field: 'OriginalFileName', header: 'שם קובץ' },
      { field: 'ReportDateFormatted', header: 'תאריך דיווח' },
      { field: 'UpdateUserId', header: 'סטטוס נקבע על ידי' },
      { field: 'ManagementName', header: 'חברה מנהלת' },
      { field: 'StatusDepositTreatmentDescription', header: 'סיבת סטטוס' },
      { field: 'Status', header: 'סטטוס הפקדה' },
      { field: 'SACHAR_MEDUVACH', header: 'שכר מדווח' },
      { field: 'SHIUR_HAFRASHA', header: 'שיעור הפרשה' },
      { field: 'SCHUM_HAFRASHA', header: 'סכום' },
      { field: 'SUG_HAFRASHA', header: 'סוג הפרשה' },
      { field: 'SUG_KUPA', header: 'סוג קופה' },
      { field: 'SHEM_KUPA', header: 'שם קופה' },
      { field: 'CHODESH_MASKORET', header: 'חודש שכר' },
      { field: 'MISPAR_MEZAHE_OVED', header: 'זיהוי עובד' },
      { field: 'SHEM_PRATI', header: 'עובד' },
      { field: 'CustomerName', header: 'שם מעסיק' },
      { field: 'IdentityNumber', header: 'זיהוי מעסיק' }
      //{ field: 'MISPAR_MEZAHE_RESHUMA', header: 'האם רשומה קיימת בקובץ הפקדות' },
    ];

    this.reportNegative = [
      {label: 'שליליים', value: '-1'},
      {label: 'רגילים', value: '1'},
      {label: 'הכל', value: '0'}
    ];
    this.reportNegativeSelected = this.reportNegative[1].value


  }

  fillReportMonth() {
    this.dataService.GetReportMonthList().subscribe((result: any) => {
      this.reportMonthes = result;
      //this.reportMonthSelected = null;
      this.reportMonthMultiSelected = null;
      
    },
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת רשימת תקופות לחודש דיווח ');
    });
  }

  fillChodeshMaskoret() {
    this.dataService.GetChodeshMaskoretList().subscribe((result: any) => {
      this.chodeshMaskoret = result;
      //this.chodeshMaskoretSelected = null;
      this.chodeshMaskoretMultiSelected = null;
    },
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת רשימת תקופות לחודש שכר ');
    });
  }


  isColumnToShow(columnsName: string): any {
    if (this.selectedColumns.indexOf(columnsName) == -1) return 'none'; else return 'table-cell';
  }

  setPrecalculated(FeedbackStatusId: string): void {
    this.accountManagerSelected = null;
    this.selectedCustomerId = null;
    this.selectedFileName = null;
    this.selectedSugHafrasha = null;
    this.selectedErrorCode = null;
    this.selectedSugKupa = null;
    this.selectedManagementName = null;
    this.selectedMisparMezaheOved = null;
    this.selectedUrgent = null;
    this.selectedLegalTreatment = null;
    this.selectedManagementName = null;
    if (FeedbackStatusId == '-1')
    {
      this.selectedStatus = [];
      this.selectedErrorCode = this.listErrorCodes[1].value;
    }
    else
    {
      this.selectedStatus = [];
      this.selectedStatus.unshift(FeedbackStatusId);

      this.selectedErrorCode = null;
    }
    this.getReport();
  }

  getReport(): void {
    this.resultTable = null;
    this.btnDialog = false;
    this.accountManagerSelected = this.accountManagerSelected === null ? '' : this.accountManagerSelected;
    this.selectedCustomerId = this.selectedCustomerId === null ? '' : this.selectedCustomerId;
    this.selectedFileName = this.selectedFileName === null ? '' : this.selectedFileName;
    this.selectedSugHafrasha = this.selectedSugHafrasha === null ? '' : this.selectedSugHafrasha;
    this.selectedErrorCode = this.selectedErrorCode === null ? '' : this.selectedErrorCode;
    this.selectedSugKupa = this.selectedSugKupa === null ? '' : this.selectedSugKupa;
    this.selectedManagementName = this.selectedManagementName === null ? '' : this.selectedManagementName;
    this.selectedMisparMezaheOved = this.selectedMisparMezaheOved === null ? '' : this.selectedMisparMezaheOved;
    this.selectedStatus = this.selectedStatus === null ? [] : this.selectedStatus;
    this.selectedErrorCodeV4 = this.selectedErrorCodeV4 === null ? [] : this.selectedErrorCodeV4;
    this.selectedUrgent = this.selectedUrgent === true ? true : false;
    this.selectedLegalTreatment = this.selectedLegalTreatment === true ? true : false;

    let reportMonthMultiSelected = this.reportMonthMultiSelected?this.reportMonthMultiSelected.join(','):'';
    let chodeshMaskoretMultiSelected = this.chodeshMaskoretMultiSelected?this.chodeshMaskoretMultiSelected.join(','):'';
    this.dataService.getReport(this.accountManagerSelected, this.selectedCustomerId, this.selectedFileName, this.selectedSugHafrasha, this.selectedSugKupa, this.selectedManagementName, this.selectedMisparMezaheOved, this.selectedStatus, this.selectedUrgent, this.rowsLimit, this.selectedErrorCode, /*this.reportMonthSelected*/ reportMonthMultiSelected, /*this.chodeshMaskoretSelected*/ chodeshMaskoretMultiSelected, this.reportNegativeSelected, this.selectedErrorCodeV4, this.selectedLegalTreatment, this.resultsTypeSelected).subscribe((result: any) => {
      this.resultTable = result;
      this.updateRowGroupMetaData();
      if (this.resultTable.length.toString() === this.rowsLimit.toString()) {
        let msg = 'סינון שנבחר הינו רחב מדי, מוצגות ' +
          this.rowsLimit.toString() +
          ' תוצאות ראשונות בלבד. נא לעדן את הסינון';
        this.showMessage('warn', '', msg);
        // this.showMessage('warn', '', 'סינון שנבחר הינו רחב מדי, מוצגות 1000 תוצאות ראשונות בלבד. נא לעדן את הסינון');
      }
      if (this.resultTable.length > 0) {
        let cnt = this.getCnt();
        if (cnt > 0) {
          this.flag = true;
          this.setCheckboxValuesInArray(this.flag);
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'שגיאה בהצגת הדוח');
      });
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.resultTable) {
      for (let i = 0; i < this.resultTable.length; i++) {
        let rowData = this.resultTable[i];
        let customer = rowData.IdentityNumberWithCustomerName;
        if (i == 0) {
          this.rowGroupMetadata[customer] = { index: 0, size: 1 };
        }
        else {
          let previousRowData = this.resultTable[i - 1];
          let previousRowGroup = previousRowData.IdentityNumberWithCustomerName;
          if (customer === previousRowGroup)
            this.rowGroupMetadata[customer].size++;
          else
            this.rowGroupMetadata[customer] = { index: i, size: 1 };
        }
      }
    }
  }


  setChecked(event: boolean, feedbackId: number): void {
    if (event) {
      let i = this.resultTable.findIndex(i => i.FeedbackId === feedbackId);
      if (i != -1) {
        this.resultTable[i].Check = true
      }
    }
    else {
      let i = this.resultTable.findIndex(i => i.FeedbackId === feedbackId);
      if (i != -1)
        this.resultTable[i].Check = false
    }
    this.setBtnDialog();
  }

  setUpdate(FeedbackId: number, FileDepositId: number, Check: boolean, MISPAR_MEZAHE_RESHUMA: string, OriginalFileName: string, FeedbackStatudUpdateDate: string, Urgent: boolean, FeedbackStatusIdOriginal: number): any {
    if ((FeedbackId === null || FeedbackId === undefined) || (!Check) || (MISPAR_MEZAHE_RESHUMA === null || MISPAR_MEZAHE_RESHUMA === undefined || MISPAR_MEZAHE_RESHUMA === "")) {
      return this.showMessage('error', '', 'שגיאה. תקלה לא צפויה');
    }

    this.cloneArray.FeedbackId = FeedbackId;
    this.cloneArray.FileDepositId = FileDepositId;
    this.cloneArray.MISPAR_MEZAHE_RESHUMA = MISPAR_MEZAHE_RESHUMA;
    this.cloneArray.OriginalFileName = OriginalFileName;
    this.cloneArray.FeedbackStatudUpdateDate = FeedbackStatudUpdateDate;
    this.cloneArray.Urgent = Urgent;
    this.cloneArray.FeedbackStatusId = FeedbackStatusIdOriginal;
    this.updateHistory = null;
    this.display = true;
    this.dataService.GetFeedbackStatusUpdateHistory(MISPAR_MEZAHE_RESHUMA).subscribe(
      (data: FeedbackUpdateHistory[]) => {
        this.updateHistory = data;
      },
      (err: HttpErrorResponse) => {
        //this.router.navigate(['error-page/', err.error.ExceptionMessage])
        this.showMessage('error', '', 'תקלה בקבלת הסטורית עדכון');
      });

  }

  setBtnDialog(): void {
    let i = this.resultTable.findIndex(i => i.Check === true);
    let cnt = this.resultTable.filter(i => i.Check === true).length;
    if (i != -1 && cnt >= 2) {
      this.btnDialog = true;
    }
    else {
      this.btnDialog = false;
    }
  }

  showArray(): void {

    this.rowsTobeUpdated = 0;
    this.resultTable.forEach(element => {
      if (element.Check === true && (element.FeedbackId !== null || element.FeedbackId !== undefined)) {
        this.rowsTobeUpdated += 1;
      }
    });
    this.cloneArray = {};
    this.updateHistory = null;
    this.display = true;


  }

  setStatus(event: number, feedbackId: number, fileDepositId: number, note: string, MISPAR_MEZAHE_RESHUMA: string, FeedbackStatusId: number): any {
    if (event !== undefined || event !== null) {
      this.cloneArray = {};
      let newArr: any[] = [];
      if ((feedbackId === null || feedbackId === undefined)) {
        this.resultTable.forEach(element => {
          if (element.Check === true && (element.FeedbackId !== null || element.FeedbackId !== undefined)) {
            newArr.push({ FeedbackId: element.FeedbackId, FileDepositId: element.FileDepositId, Notes: note, MISPAR_MEZAHE_RESHUMA: element.MISPAR_MEZAHE_RESHUMA, FeedbackStatusId: element.FeedbackStatusIdOriginal });
          }
        });
        let ok = confirm(`האם ברצונך לעדכן ${newArr.length} רשומות?`);
        if (ok) {
          this.dataService.setFeedbackAndDeposit(newArr, event).subscribe((result: any) => {
            if (result === "Success") {
              this.display = false;
              this.getReport();
              newArr = [];
              this.btnDialog = false;
              this.showMessage('success', '', 'נשמר בהצלחה');
            }
            else {
              this.display = false;
            }
          },
            (err: HttpErrorResponse) => {
              //this.router.navigate(['error-page/', err.error.ExceptionMessage])
              this.showMessage('error', '', 'שגיאה לא צפויה. תקלה בשמירה');
              this.display = false;
            });
        }
        else {
          this.display = false;
          newArr = [];
        }
      }
      else if ((feedbackId !== null || feedbackId !== undefined)) {
        newArr.push({ FeedbackId: feedbackId, FileDepositId: fileDepositId, Notes: note, MISPAR_MEZAHE_RESHUMA: MISPAR_MEZAHE_RESHUMA, FeedbackStatusId: FeedbackStatusId });
        let ok = confirm(`האם ברצונך לעדכן ${newArr.length} רשומות?`);
        if (ok) {
          this.dataService.setFeedbackAndDeposit(newArr, event).subscribe((result: any) => {
            if (result === "Success") {
              this.display = false;
              this.getReport();
              newArr = [];
              this.btnDialog = false;
              this.showMessage('success', '', 'נשמר בהצלחה');
            }
            else {
              this.display = false;
            }
          },
            (err: HttpErrorResponse) => {
              //this.router.navigate(['error-page/', err.error.ExceptionMessage])
              this.showMessage('error', '', 'שגיאה לא צפויה. תקלה בשמירה');
              this.display = false;
            });
        }
        else {
          this.display = false;
          newArr = [];
        }
      }
      else {
        this.display = false;
        newArr = [];
      }
    }
    else {
      this.showMessage('error', '', 'שגיאה. תקלה לא צפויה');
      this.display = false;
      this.cloneArray = {};
      return;
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  getCnt(): number {
    let cnt = this.resultTable.filter(i => (i.FeedbackId !== null || i.FeedbackId !== undefined) && (i.MISPAR_MEZAHE_RESHUMA !== null || i.MISPAR_MEZAHE_RESHUMA !== "")).length;
    return cnt;
  }

  setCheckboxValuesInArray(event: boolean): void {
    if (event) {
      let filteredValueCnt: number = -1;
      // try {
      //   filteredValueCnt = this.dataTable.filteredValue.length;
      // } catch (error) {
      //   filteredValueCnt = -1;
      // }
      try {
        if (this.dataTable) {
          if (this.dataTable.filteredValue) {
            filteredValueCnt = this.dataTable.filteredValue.length;
          }
          else {
            filteredValueCnt = -1;
          }
        }
        else {
          filteredValueCnt = -1;
        }
      } catch (error) {
        filteredValueCnt = -1;
      }

      if (filteredValueCnt === -1) {
        for (let i = 0; i < this.resultTable.length; i++) {
          let element = this.resultTable[i];
          if ((element.FeedbackId) ) {
            this.setChecked(true, element.FeedbackId);
            this.flag = true;
          }
        }
      }
      else if (filteredValueCnt > 0) {
        for (let i = 0; i < this.dataTable.filteredValue.length; i++) {
          let element = this.dataTable.filteredValue[i];
          if ((element.FeedbackId)) {
            this.setChecked(true, element.FeedbackId);
            this.flag = true;
          }
        }
      }
      else if (filteredValueCnt === 0) {
        this.flag = false;
        this.showMessage('info', '', 'לא נמצאו נתונים עבור הסינון שנבחר');
      }
    }
    else {
      for (let i = 0; i < this.resultTable.length; i++) {
        let element = this.resultTable[i];
        if ((element.FeedbackId) ) {
          this.setChecked(false, element.FeedbackId);
          this.flag = false;
        }
      }
    }
  }

  onFilter(): void {
    this.setCheckboxValuesInArray(false);
    this.setCheckboxValuesInArray(true);
  }

  onSort() {
    this.updateRowGroupMetaData();
  }

  downloadFeedbackReport(): void {
    // if (!confirm("הפקת דוח צפויה להימשך זמן רב, האם להמשיך?")) {return;}
    let fileName = 'FeedbackReport.zip';

    try {
      // this.showMessage('info', '', 'הפקת הדוח הופעלה, הדוח יהיה מוכן בעוד מספר דקות.');
      this.dataService.downloadFeedbackReportZip(this.downloadFileGuid).subscribe((result: any) => {
        window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(result, fileName);
        }
        let url = window.URL.createObjectURL(result)
        let link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}`;
        link.click();
        setTimeout(() => {
          this.showMessage('success', '', 'הדוח הורד בהצלחה');
        }, 1000);
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בהורדת דוח');
      });
    } catch (error) {
      this.showMessage('error', '', 'תקלה בהורדת הקובץ');
    }

  }

  getFeedbackReport(): void {
    if (!confirm("הפקת דוח צפויה להימשך זמן רב, האם להמשיך?")) { return; }
    this.dataService.getFeedbackReport().subscribe((result: any) => {
      this.showMessage('success', '', 'הדוח תוזמן ובסיום הפקה יישלח מייל למנהל המערכת');
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בתזמון הפקת דוח ');
      });
  }


  // customSort(e) {
  //   this.resultTable.sort((a, b) => {
  //     const aGroup = a.name.toLowerCase();
  //     const bGroup = b.name.toLowerCase();
  //     if (aGroup > bGroup) { return 1; }
  //     if (aGroup < bGroup) { return -1; }
  //     const aSort = a.color;
  //     const bSort = b.color;
  //     if (aSort > bSort) { return 1; }
  //     if (aSort < bSort) { return -1; }
  //     return 0;
  //   });
  // }


  getFeedbackErrorCodeDescription(code):void{
    try {
      if (code==null || code=='') {return;}
      this.FeedbackError = null;
      this.dataService.getFeedbackErrorCodeDescription(code).subscribe((result: any) => {
        this.FeedbackError = result;
        this.showFeedbackErrorCodeDescription = true;
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת תאור קוד שגיאה');
      });
    } catch (error) {
      this.showMessage('error', '', 'תקלה לא צפויה בקבלת תאור קוד שגיאה');
    }
  }

  getFeedbackErrorCodeV4Description(row):void{
        this.FeedbackV4Error = row.ErrorCodeV4Description;
        this.showFeedbackErrorCodeV4Description = true;
  }

  FeedbackErrorCodeDescriptionClosed(): void {
    this.FeedbackError = null;
  }

  FeedbackErrorCodeV4DescriptionClosed(): void {
    this.FeedbackV4Error = null;
  }

  accountManagerChanged() {
    this.dataService.getCustomersDDL(this.accountManagerSelected).subscribe((result: any) => {
      this.listcustomer = result;
      this.listcustomer.unshift({ label: 'הכל', value: null });
      this.selectedCustomerId = null;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים ');
      });
  }

  isInLegalTreatment(rowData) {
    if (rowData.FeedbackStatusIdOriginal==6 && rowData.inLegalTreatment == true) {
      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/feedback/feedback.component.ts